import { ComponentProps } from "react";

import { ContactAndBillingInput } from "@components/ContactAndBillingInput/ContactAndBillingInput";

export const toContactAndBillingInputProps = (
  form: any
): ComponentProps<typeof ContactAndBillingInput> => ({
  name: form.getInputProps("name"),
  lastName: form.getInputProps("lastName"),
  firstName: form.getInputProps("firstName"),
  address: {
    type: form.getInputProps("address.type"),
    city: form.getInputProps("address.city"),
    phone: {
      code: form.getInputProps("address.phone.code"),
      number: form.getInputProps("address.phone.number"),
    },
    country: form.getInputProps("address.country"),
    postCode: form.getInputProps("address.postCode"),
    streetAndHouse: form.getInputProps("address.streetAndHouse"),
  },
  billingAddress: {
    name: form.getInputProps("billingAddress.name"),
    type: form.getInputProps("billingAddress.type"),
    city: form.getInputProps("billingAddress.city"),
    phone: {
      code: form.getInputProps("billingAddress.phone.code"),
      number: form.getInputProps("billingAddress.phone.number"),
    },
    country: form.getInputProps("billingAddress.country"),
    options: form.getInputProps("billingAddress.options"),
    postCode: form.getInputProps("billingAddress.postCode"),
    streetAndHouse: form.getInputProps("billingAddress.streetAndHouse"),

    additionToInvoice: form.getInputProps("billingAddress.additionToInvoice"),
    contactPersonOnInvoice: form.getInputProps(
      "billingAddress.contactPersonOnInvoice"
    ),
  },
  isBillingAddressSame: form.getInputProps("isBillingAddressSame"),
});
